export default __webpack_public_path__ + "static/media/icons8-logotipo-de-java-coffee-cup.d5ed96c7.svg";